import ServiceButton from "../ServiceButton/ServiceButton"
import styles from "./ContentDisplay.module.css"

const ContentDisplay = ({ content, services, activeService, setActiveService }) => {
  return (
    <div className={styles.container}>
      <div className={styles.buttonGrid}>
        {services.map((service) => (
          <ServiceButton
            key={service.id}
            icon={service.icon}
            label={service.label}
            isActive={service.id === activeService}
            onClick={() => setActiveService(service.id)}
          />
        ))}
      </div>
      <div className={styles.contentSection}>
        <div className={styles.textContent}>
          <h2 className={styles.title}>{content.title}</h2>
          <p className={styles.description}>{content.description}</p>
        </div>
        <div className={styles.imageContainer}>
          <img src={content.image || "/placeholder.svg"} alt={content.title} className={styles.image} />
        </div>
      </div>
    </div>
  )
}

export default ContentDisplay

